import { render, staticRenderFns } from "./CodePopup.vue?vue&type=template&id=7f5884ce&scoped=true"
import script from "./CodePopup.vue?vue&type=script&lang=js"
export * from "./CodePopup.vue?vue&type=script&lang=js"
import style0 from "./CodePopup.vue?vue&type=style&index=0&id=7f5884ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5884ce",
  null
  
)

export default component.exports